module.exports = __webpack_public_path__ + "media/assets/community_index/icon-arrow-right-83099becfac2e42a89188a26e11d3fe09a7cb2e2104ed931504e326bc7237e6e.png";